<template>
<h1 :style="titleStyle" class="title text-header">
    {{ channel.title }}
    <FontLoader :fontConfig="fontConfig" :styleObj.sync="titleFontStyle" />
</h1>
</template>

<script>
import * as M from '@/store/mutations'
import FontLoader from '@/font-loader/FontLoader'
import { gradientStringToStyleObj } from '@/utils'

export default {
    name: 'HeaderText',
    props: {
        channel: Object,
    },
    data: () => ({
        titleFontStyle: {},
    }),
    computed: {
        channelId: vm => vm.channel.channelId,
        titleFontSize: vm => vm.channel.titleFontSize,
        titleFontUrl: vm => vm.channel.titleFontUrl,
        titleGradient: vm => vm.channel.titleGradient,
        headerStyle: vm => ({ fontSize: vm.titleFontSize + 'px' }),
        titleStyle: vm => {
            let style = {
                fontSize: vm.titleFontSize + 'px',
                ...vm.gradientStringToStyleObj,
            }

            if (vm.titleFontUrl) {
                style = { ...style, ...vm.titleFontStyle }
            }

            return style
        },
        // Convert a string -> "color: red",
        // to an object     -> { color: 'red' }
        gradientStringToStyleObj: vm => gradientStringToStyleObj(vm.titleGradient),
        fontConfig: vm => {
            const mutation = M.SET_TITLE_FONT_LOADING_STATE
            return {
                fontUrl: vm.titleFontUrl,
                mutation,
                channelId: vm.channelId,
                fontKey: `${vm.channelId}-${mutation}`,
                text: vm.channel.title,
            }
        },
    },
    components: {
        FontLoader,
    }
}
</script>

<style lang="scss" scoped>
// Override some of the bulma .title styling
.text-header {
    position: relative;
    background: var(--theme-color);
    color: var(--theme-color-contrast);
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    padding: 10px;
    text-align: center;
    font-weight: normal;
    margin-bottom: 0 !important;
}

</style>
